import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-override" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 11 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.787794 0.000340998C0.631812 0.000381975 0.479387 0.0469545 0.350004 0.134104C0.220621 0.221254 0.120161 0.345022 0.0614663 0.489583C0.00277158 0.634145 -0.0114904 0.792932 0.0205036 0.945644C0.0524977 1.09836 0.129294 1.23805 0.241074 1.34688L4.39124 5.49832L0.241074 9.64975C0.165823 9.72203 0.105743 9.80859 0.0643549 9.90438C0.0229668 10.0002 0.00110191 10.1033 4.05857e-05 10.2076C-0.00102073 10.312 0.018743 10.4155 0.0581743 10.5121C0.0976055 10.6087 0.155912 10.6965 0.229678 10.7702C0.303444 10.844 0.391188 10.9024 0.48777 10.9418C0.584352 10.9812 0.687831 11.001 0.792147 11C0.896463 10.9989 0.999519 10.977 1.09528 10.9356C1.19104 10.8942 1.27758 10.8341 1.34983 10.7588L5.5 6.60741L9.65017 10.7588C9.72242 10.8341 9.80896 10.8942 9.90472 10.9356C10.0005 10.977 10.1035 10.9989 10.2078 11C10.3122 11.001 10.4156 10.9812 10.5122 10.9418C10.6088 10.9024 10.6966 10.844 10.7703 10.7703C10.8441 10.6965 10.9024 10.6087 10.9418 10.5121C10.9813 10.4155 11.001 10.312 11 10.2076C10.9989 10.1033 10.977 10.0002 10.9356 9.90438C10.8943 9.80859 10.8342 9.72203 10.7589 9.64975L6.60875 5.49832L10.7589 1.34688C10.8722 1.23671 10.9496 1.09487 10.9809 0.939949C11.0123 0.785028 10.9961 0.624253 10.9345 0.478692C10.8729 0.333131 10.7688 0.209576 10.6358 0.124218C10.5028 0.0388602 10.3472 -0.00431821 10.1892 0.000340998C9.98552 0.00641261 9.79218 0.0915746 9.65017 0.237785L5.5 4.38922L1.34983 0.237785C1.27676 0.16265 1.18938 0.102928 1.09284 0.0621449C0.99631 0.0213623 0.892584 0.000347109 0.787794 0.000340998Z",
    fill: "black"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Admin Override", -1)
const _hoisted_5 = { class: "mini-nav" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString(" | "), -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString(" | "), -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Email:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "admin-output-log"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "This will override season flags locally, only for yourself, and will persist across account proxies until you refresh. Use the Admin View to change these flags for everyone.", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Feature"),
  /*#__PURE__*/_createElementVNode("th", null, "State")
], -1)
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { value: undefined }
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", null, "This will change the viewed season", -1)
const _hoisted_18 = { class: "link-container" }
const _hoisted_19 = { class: "link" }
const _hoisted_20 = { class: "link" }
const _hoisted_21 = {
  key: 0,
  class: "disabled"
}
const _hoisted_22 = { class: "link" }
const _hoisted_23 = {
  key: 0,
  class: "disabled"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock($setup["SimpleModal"], {
    onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_3),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            class: _normalizeClass({active: $setup.adminPanelState === 'proxy'}),
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.adminPanelState = 'proxy'))
          }, "Proxy", 2),
          _hoisted_6,
          _createElementVNode("a", {
            class: _normalizeClass({active: $setup.adminPanelState === 'flags'}),
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.adminPanelState = 'flags'))
          }, "Season Flags", 2),
          _hoisted_7,
          _createElementVNode("a", {
            class: _normalizeClass({active: $setup.adminPanelState === 'season'}),
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.adminPanelState = 'season'))
          }, "Season Navigation", 2)
        ]),
        _hoisted_8,
        ($setup.adminPanelState === 'proxy')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.adminOverrideEmail) = $event)),
                placeholder: "example@email.com"
              }, null, 512), [
                [_vModelText, $setup.adminOverrideEmail]
              ]),
              _hoisted_10,
              _createElementVNode("button", { onClick: $setup.doAdminOverride }, "Submit"),
              _createElementVNode("button", { onClick: $setup.clearAdminOverride }, "Clear"),
              ($setup.adminOverrideLog)
                ? (_openBlock(), _createElementBlock("pre", _hoisted_11, _toDisplayString($setup.adminOverrideLog), 1))
                : _createCommentVNode("", true)
            ], 64))
          : ($setup.adminPanelState === 'flags')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_12,
                _createElementVNode("table", null, [
                  _hoisted_13,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.Season.Features, (feature) => {
                    return (_openBlock(), _createElementBlock("tr", { key: feature }, [
                      _createElementVNode("td", null, _toDisplayString(feature), 1),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => (($setup.seasonStore.seasonFlagOverrides[feature]) = $event)
                        }, [
                          _createElementVNode("option", _hoisted_15, "Unchanged (" + _toDisplayString($setup.seasonStore.current?.features[feature]) + ")", 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.Season.FeatureState, (state) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: state,
                              value: state
                            }, _toDisplayString(state), 9, _hoisted_16))
                          }), 128))
                        ], 8, _hoisted_14), [
                          [_vModelSelect, $setup.seasonStore.seasonFlagOverrides[feature]]
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.seasonStore.clearSeasonFlagOverrides && $setup.seasonStore.clearSeasonFlagOverrides(...args)))
                }, "Clear")
              ], 64))
            : ($setup.adminPanelState === 'season')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("a", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.routeToPage('/shopping-home')))
                      }, "Go to Shopping Portal")
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      ($setup.registrationEnabled === $setup.Season.FeatureState.DISABLED)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_21, "Registration Flag Disabled"))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.routeToPage('/registration')))
                          }, "Go to Registration"))
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      ($setup.checklistEnabled   === $setup.Season.FeatureState.DISABLED)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_23, "Checklist Flag Disabled"))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.routeToPage('/builder/dashboard')))
                          }, "Go to Builder Dashboard"))
                    ])
                  ]),
                  _createVNode($setup["SeasonSelector"], {
                    modelValue: $setup.selectedSeason,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.selectedSeason) = $event))
                  }, null, 8, ["modelValue"])
                ], 64))
              : _createCommentVNode("", true),
        _hoisted_24,
        _createElementVNode("a", {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('openTripAssignment')))
        }, "Open Trip Assignment"),
        _hoisted_25,
        _createVNode(_component_router_link, { to: "/admin/lottery" }, {
          default: _withCtx(() => [
            _createTextVNode("Go to Admin View")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}